import { localize } from "@/plugins/fmt/modules/localize"
import { DEFAULT_TZ } from "@/utils/date"

export const state = () => ({
  event: null,
  asideExpanded: true, // TODO: remove
  menu: [],
  statuses: [],
  historyLen: 0,
  customEvent: "",
  applicationState: "",
})

export const getters = {
  description (state, _getters, { i18n: { locale } }) {
    const description = state.event?.description
    return description ? localize(locale, description) : ""
  },

  getTitle: (state, _getters, { i18n: { locale } }) => (pageTitle = "") => {
    const title = localize(locale, state.event?.title)
    if (pageTitle)
      if (title) return `${pageTitle} · ${title}`
      else return pageTitle
    else if (title) return title
    else return ""
  },

  asideExpanded: state => state.asideExpanded, // TODO: remove

  timezone: state => state.event?.timezone || DEFAULT_TZ,
}

export const mutations = {
  SET_EVENT (state, event) { state.event = event },
  SET_ASIDE (state, aside) { state.asideExpanded = aside }, // TODO: remove
  SET_MENU (state, menu) { state.menu = menu },
  SET_STATUSES (state, statuses) { state.statuses = statuses },
  SET_HISTORY_LEN: (state, historyLen) => { state.historyLen = historyLen },
  SET_CUSTOM_EVENT: (state, customEvent) => { state.customEvent = customEvent },
  SET_APPLICATION_STATE: (state, value) => { state.applicationState = value },
}

export const actions = {
  async FETCH_EVENT ({ commit }) {
    const [res, err] = await this.$api.event.getEventData()
    if (err) console.error(err.message)
    else commit("SET_EVENT", res)
  },

  async FETCH_MENU ({ commit }) {
    const [res, err] = await this.$api.event.getMenu()
    if (err) console.error(err.message)
    else commit("SET_MENU", this.$api.helpers.getList(res))
  },

  async FETCH_STATUSES ({ commit }) {
    const [res, err] = await this.$api.event.getStatuses()
    if (err) console.error(err.message)
    else commit("SET_STATUSES", this.$api.helpers.getList(res))
  },

  UPDATE_APPLICATION_STATE ({ commit }, value) {
    commit("SET_APPLICATION_STATE", value)
  },
}
